import { useState,  useMemo } from "react";
import {
  Container,
  Box,
  Button,
  TextField,
  MenuItem,
  CircularProgress,
  Paper,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Modal,
  Tabs,
  Tab,
  Grid,
  InputLabel,
  FormControl,
  Select,
  InputAdornment,
  FormControlLabel,
  Checkbox,
  FormHelperText,
  Card,
  CardContent

} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { DiseñoDataGrid } from "../../Components/FuncionesGenerales/DataGrid";
import { useGetSucursal } from "../../Services/Sucursales";
import { cargaMasiva } from "../../Services/IngresoPaciente"; 
import { BsFileEarmarkRuledFill } from "react-icons/bs";
import { IoCreate } from "react-icons/io5";
import Logocolor from "../../Image/Logo.png";
import { formatCLP } from "../../Components/FuncionesGenerales/FormatoCLP";
import { IoPeople } from "react-icons/io5";
import { FormatRut } from "../../Components/FuncionesGenerales/Rut";
import {
  Texto,
  buttonGuardar,
  buttonAtras,
  Input,
  buttonCancelar,
  TituloColor,
  modalStyle,
  inputFecha,
  InputDescripcion,
  InputBuscador,
  TituloPrincipal
} from "../../Layouts/CustomStyles";
import { IoClose } from "react-icons/io5";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";
import { IndexCargaMasiva } from "../../Components/CBO/IngresoPaciente";
import { useGetProfesional } from "../../Services/Profesional";
import { useGetIngresosMasivos } from "../../Services/IngresoPaciente";
import { useIngresoPaciente } from "../../Services/IngresoPaciente";
import { BusquedaPaciente } from "../../Components/CBO/IngresoPaciente/BusquedaPaciente";
import { useDeudoresCBO } from "../../Services/Deudores";
import { IoTrash } from "react-icons/io5";
import { GiMoneyStack } from "react-icons/gi";
import { useGetPrevision } from "../../Services/Prevision";
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';


export const PaginaIngresoPaciente = () => {
  const { postIngresoPacienteManual, eliminarIngresoPacienteMesyAño } = useIngresoPaciente();
  const [openConfirmEliminar, setOpenConfirmEliminar] = useState(false);
  const { Prevision } = useGetPrevision();
  const { ingresosPacientes, refetchBP, refetchIP, informacionMontos, informacionMontosAnteriores, loadingsIngresosMontos } = useGetIngresosMasivos();
  const { SincornizacionPacienteDeudor, detectarNoPago, confirmarNoPago, } = useDeudoresCBO()
  const [tabIndex, setTabIndex] = useState(0);
  const [buscandoPaciente, setBuscandoPaciente] = useState(false);
  const [openImportDialog, setOpenImportDialog] = useState(false);
  const [openCrearDialog, setOpenCrearDialog] = useState(false);
  const { sucursales } = useGetSucursal();
  const { profesional } = useGetProfesional();
  const [formData, setFormData] = useState({
    branch_id: "",
    archivo: null,
  });
  const [crearIngreso, setCrearIngreso] = useState({
    fecha: "",
    fecha_pago: "",
    rut: "",
    kine: "",
    nombre_paciente: "",
    estado_paciente: "",
    prevision: "",
    medico_tratante: "",
    branch_id: "",
    profesional: "",
    n_sesiones: "",
    episodio: "",
    estado_pago: "NO PAGO",
    monto: "",
    valor: "",
    observaciones: ""
  });

 const [openConfirmNoPagoDialog, setOpenConfirmNoPagoDialog] = useState(false);
const [noPagosDetectados, setNoPagosDetectados] = useState([]);
const [confirmandoId, setConfirmandoId] = useState(null);



  const [loading, setLoading] = useState(false);
  const [successAlertOpen, setSuccessAlertOpen] = useState(false);
  const [errorAlertOpen, setErrorAlertOpen] = useState(false);
  const [enviandoAlert, setEnviandoAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [openDeudoresDialog, setOpenDeudoresDialog] = useState(false); // 🔹 nuevo modal
  const [nuevosDeudores, setNuevosDeudores] = useState([]); // 🔹 datos del backend
  const [actualizarTabla, setActualizarTabla] = useState(false);
  const [openEliminarDialog, setOpenEliminarDialog] = useState(false);
  const [mesEliminar, setMesEliminar] = useState('');
  const [anioEliminar, setAnioEliminar] = useState('');
   const [SucursalEliminar, setSucursalEliminar] = useState('');
  const branchName = sucursales?.find(s => s.id === Number(crearIngreso.branch_id))?.name || "";

  const profesionalesFiltrados = profesional.filter((p) => {
    // excluir área 1
    if (p.id_area_servicio === "5") return false;

    // Mostrar todos
    if (crearIngreso.kine === "TODOS") return true;

    // Si no hay sucursal seleccionada → todos
    if (!crearIngreso.branch_id) return true;

    // Filtrar por sucursal
    return (
      p.sucursal_uno === branchName ||
      p.sucursal_dos === branchName
    );
  });


  const nombresMeses = [
    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
  ];

  const formatearPeriodo = (periodo) => {
    if (!periodo) return "";
    const [anio, mes] = periodo.split("-");
    const nombreMes = nombresMeses[Number(mes) - 1];
    return `${nombreMes} ${anio}`;
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;

    // Formatear el RUT mientras se escribe
    if (name === "rut") formattedValue = FormatRut(value);

    // Capitalizar nombre del paciente
    if (name === "nombre_paciente") {
      formattedValue = value
        .toLowerCase()
        .replace(/\b\w/g, (l) => l.toUpperCase());
    }

    // Convertir branch_id y profesional a número
    if (name === "branch_id" || name === "profesional") {
      formattedValue = value ? Number(value) : null;
    }

    // Formatear como pesos chilenos
    if (name === "monto" || name === "valor") {
      // eliminar puntos o símbolos y convertir a número
      const numericValue = Number(value.toString().replace(/\D/g, ""));
      formattedValue = numericValue ? numericValue : "";

      setCrearIngreso((prev) => ({
        ...prev,
        monto: numericValue,
        valor: numericValue,
      }));
      return;
    }

    setCrearIngreso((prev) => ({
      ...prev,
      [name]: formattedValue,
    }));
  };

  // 🔎 Buscar paciente únicamente por RUT
  const handleBuscarPaciente = async () => {
    // Limpiar puntos y guión, convertir a mayúscula
    const busqueda = crearIngreso.rut.replace(/\./g, '').replace(/-/g, '').toUpperCase();

    // Validar que tenga al menos 7 caracteres
    if (busqueda.length < 7) return;

    setBuscandoPaciente(true); // ✅ Muestra el loader

    try {
      const resultados = await refetchBP(busqueda);

      if (Array.isArray(resultados) && resultados.length > 0) {
        const paciente = resultados[0];

        // Formatear nombre
        const nombreFormateado = paciente.nombre_paciente
          ? paciente.nombre_paciente
            .toLowerCase()
            .replace(/\b\w/g, (l) => l.toUpperCase())
          : "";

        const previsionEncontrada = Prevision?.find(
          (p) => p.id === paciente.prevision || p.nombre === paciente.prevision
        );
        setCrearIngreso((prev) => ({
          ...prev,
          nombre_paciente: nombreFormateado,
           prevision: previsionEncontrada?.nombre || "",
        }));
      } else {
        console.warn("⚠️ No se encontraron pacientes");
        setCrearIngreso((prev) => ({
          ...prev,
          nombre_paciente: "",
          prevision: "",
        }));
      }
    } catch (error) {
      console.error("💥 Error al buscar paciente:", error);
    } finally {
      setBuscandoPaciente(false); // ✅ Oculta el loader
    }
  };



  const handleFileChange = (e) => {
    setFormData({ ...formData, archivo: e.target.files[0] });
  };
  const handleTabChange = (event, newValue) => setTabIndex(newValue);

 const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.archivo) {
    setAlertMessage("Por favor selecciona un archivo Excel antes de continuar.");
    setErrorAlertOpen(true);
    return;
  }

  setLoading(true);
  setEnviandoAlert(true);

  const formDataToSend = new FormData();
  formDataToSend.append("branch_id", formData.branch_id);
  formDataToSend.append("archivo", formData.archivo);

  try {
    // 1️⃣ CARGA MASIVA
    await cargaMasiva(formDataToSend);
    await refetchIP();

    // 2️⃣ DETECTAR REGULARIZACIONES (UNA SOLA VEZ)
    const regularizaciones = await detectarNoPago(); // 👈 SIN PAYLOAD

    if (Array.isArray(regularizaciones) && regularizaciones.length > 0) {
      setNoPagosDetectados(regularizaciones);
      setOpenConfirmNoPagoDialog(true);
      return; // ⛔ esperar confirmación del usuario
    }

    // 3️⃣ SI NO HAY REGULARIZACIONES
    await continuarSincronizacion();

  } catch (error) {
    console.error(error);
    setAlertMessage(
      error?.response?.data?.message ||
      "Ocurrió un error al importar el archivo ❌"
    );
    setErrorAlertOpen(true);
  } finally {
    setLoading(false);
    setEnviandoAlert(false);
  }
};



const continuarSincronizacion = async () => {
  const resultadoSync = await SincornizacionPacienteDeudor();

  if (resultadoSync.total_nuevos > 0) {
    setNuevosDeudores(resultadoSync.data);
    setOpenDeudoresDialog(true);
  }

  setAlertMessage("Archivo importado correctamente ✅");
  setSuccessAlertOpen(true);
  setOpenImportDialog(false);
};



const handleConfirmarNoPago = async (id) => {
  try {
    setConfirmandoId(id);
    await confirmarNoPago(id);

    setNoPagosDetectados(prev =>
      prev.filter(p => p.no_pago_anterior.id !== id)
    );

  } catch (error) {
    setAlertMessage("Error al confirmar regularización ❌");
    setErrorAlertOpen(true);
  } finally {
    setConfirmandoId(null);
  }
};


const handleNoConfirmar = (id) => {
  setNoPagosDetectados(prev =>
    prev.filter(p => {
      if (!p.no_pago_anterior) return true;
      return p.no_pago_anterior.id !== id;
    })
  );
};


const handleCloseDialog = () => {
  setOpenConfirmNoPagoDialog(false);
  continuarSincronizacion(); 
};




  const handleSubmitManual = async (e) => {
    e.preventDefault();
    setEnviandoAlert(true);
    try {
      setLoading(true);
      await postIngresoPacienteManual(crearIngreso);
      setEnviandoAlert(false);
      setAlertMessage("Paciente ingresado correctamente ✅");
      setSuccessAlertOpen(true);
      setCrearIngreso({
        fecha: "",
        fecha_pago: "",
        rut: "",
        kine: "",
        nombre_paciente: "",
        estado_paciente: "",
        prevision: "",
        medico_tratante: "",
        branch_id: "",
        profesional: "",
        n_sesiones: "",
        episodio: "",
        estado_pago: "",
        monto: "",
        valor: "",
        observaciones: ""
      });
      await refetchIP();
      setActualizarTabla(prev => !prev);
      setOpenCrearDialog(false)
    } catch (error) {
      setAlertMessage("Ocurrió un error al ingresar el paciente ❌");
      setErrorAlertOpen(true);
    } finally {
      setLoading(false);
      setEnviandoAlert(false);
    }
  };

  const obtenerMesesYAniosRepetidos = (lista) => {
    const meses = {};
    const anios = {};

    lista.forEach((item) => {
      if (!item.fecha_pago) return;

      const [anio, mes] = item.fecha_pago.split("-"); // EJ: "2025", "10"

      // contar meses
      if (!meses[`${anio}-${mes}`]) meses[`${anio}-${mes}`] = 0;
      meses[`${anio}-${mes}`]++;

      // contar años
      if (!anios[anio]) anios[anio] = 0;
      anios[anio]++;
    });

    const mesesRepetidos = Object.entries(meses)
      .filter(([_, count]) => count > 1)
      .map(([mesAnio]) => mesAnio);

    const aniosRepetidos = Object.entries(anios)
      .filter(([_, count]) => count > 1)
      .map(([anio]) => anio);

    return {
      mesesRepetidos,
      aniosRepetidos
    };
  };

  // === OBTENER RESULTADO ===
  const { mesesRepetidos, aniosRepetidos } = obtenerMesesYAniosRepetidos(ingresosPacientes);

  // === PASARLOS A SELECT ===
  const mesesDisponibles = [...new Set(
    mesesRepetidos.map((m) => m.split("-")[1]) // solo mes
  )];

  const aniosDisponibles = [...new Set(aniosRepetidos)];


  const safeNumber = (item) => {
    const raw = item?.valor ?? 0; 

    if (!raw) return 0;

    
    const str = String(raw);

 
    const limpio = str.replace(/\./g, "");

    const n = Number(limpio);
    return isNaN(n) ? 0 : n;
  };


  const mapaSucursales = {};
  sucursales?.forEach((s) => {
    mapaSucursales[s.id] = s.name;
  });

  const getPacienteKey = (item) => {
    if (item.rut && item.rut.trim() !== "") {
      return `RUT:${item.rut.trim().toLowerCase()}`;
    }

    if (item.nombre_paciente && item.nombre_paciente.trim() !== "") {
      return `NOMBRE:${item.nombre_paciente
        .toLowerCase()
        .replace(/\s+/g, " ")
        .trim()}`;
    }

    return null;
  };
const mesesAgrupados = (ingresosPacientes || []).reduce((acc, item) => {

  // 🔐 Normalizar estado_pago
  const estadoPago = String(item.estado_pago ?? "")
    .trim()
    .toUpperCase();

  // 🚫 Solo considerar PAGADO
  if (estadoPago !== "PAGADO") return acc;

  // 🚫 Solo considerar registros con fecha_pago válida
  if (!item.fecha_pago) return acc;

  const partesFecha = item.fecha_pago.split("-");
  if (partesFecha.length < 2) return acc;

  const [year, month] = partesFecha;
  const clave = `${year}-${month}`;

  // 🗂 Crear estructura del mes si no existe
  if (!acc[clave]) {
    acc[clave] = {
      periodo: clave,
      total: 0,
      registros: [],
      pacientesUnicos: new Set(),
      cantidad: 0,
      totalesSucursal: {}
    };
  }


  const monto = Number(item.monto ?? 0);

 
  acc[clave].total += monto;
  acc[clave].registros.push(item);

  // 👤 Pacientes únicos
  const pacienteKey = getPacienteKey(item);
  if (pacienteKey) {
    acc[clave].pacientesUnicos.add(pacienteKey);
    acc[clave].cantidad = acc[clave].pacientesUnicos.size;
  }

  const sucursal = item.branch_name ?? "Sin sucursal";

  if (!acc[clave].totalesSucursal[sucursal]) {
    acc[clave].totalesSucursal[sucursal] = {
      sucursal,
      total: 0,
      registros: [],
      pacientesUnicos: new Set(),
      cantidad: 0
    };
  }

  // 🔢 Sumar por sucursal
  acc[clave].totalesSucursal[sucursal].total += monto;
  acc[clave].totalesSucursal[sucursal].registros.push(item);

  if (pacienteKey) {
    acc[clave].totalesSucursal[sucursal].pacientesUnicos.add(pacienteKey);
    acc[clave].totalesSucursal[sucursal].cantidad =
      acc[clave].totalesSucursal[sucursal].pacientesUnicos.size;
  }

  return acc;

}, {});



  Object.values(mesesAgrupados).forEach(mes => {
    delete mes.pacientesUnicos;

    mes.totalesSucursal = Object.values(mes.totalesSucursal).map(s => {
      delete s.pacientesUnicos;
      return s;
    });
  });



  // -------------------------------
  // ORDENAR POR PERIODO
  // -------------------------------
  const listaMeses = Object.values(mesesAgrupados).sort(
    (a, b) => a.periodo.localeCompare(b.periodo)
  );

  // ------------------------------------------------------
  //  AGREGAR TOTALES POR SUCURSAL
  // -------------------  -----------------------------------
  
const esNoPago = (item) =>
  String(item.estado_pago ?? "")
    .trim()
    .toUpperCase() === "NO PAGO";

listaMeses.forEach((mes) => {

  // ✅ 1. FILTRAR REGISTROS
  const registrosValidos = mes.registros.filter(
    (item) => !esNoPago(item)
  );

  // ✅ 2. REEMPLAZAR REGISTROS
  mes.registros = registrosValidos;

  // ✅ 3. RECALCULAR TOTAL DEL MES
  mes.total = registrosValidos.reduce(
    (sum, item) => sum + safeNumber(item),
    0
  );

  // ✅ 4. RECALCULAR PACIENTES ÚNICOS DEL MES
  const pacientesUnicosMes = new Set();
  registrosValidos.forEach((item) => {
    const key = getPacienteKey(item);
    if (key) pacientesUnicosMes.add(key);
  });
  mes.cantidad = pacientesUnicosMes.size;

  // ✅ 5. TOTALES POR SUCURSAL
  const totales = registrosValidos.reduce((acc, item) => {
    const idSucursal = item.branch_id ?? null;
    const nombreSucursal = mapaSucursales[idSucursal] || "Sin Sucursal";

    if (!acc[nombreSucursal]) {
      acc[nombreSucursal] = {
        sucursal: nombreSucursal,
        total: 0,
        pacientesUnicos: new Set(),
        cantidad: 0,
      };
    }

    acc[nombreSucursal].total += safeNumber(item);

    const pacienteKey = getPacienteKey(item);
    if (pacienteKey) {
      acc[nombreSucursal].pacientesUnicos.add(pacienteKey);
      acc[nombreSucursal].cantidad =
        acc[nombreSucursal].pacientesUnicos.size;
    }

    return acc;
  }, {});

  mes.totalesSucursal = Object.values(totales).map((s) => {
    delete s.pacientesUnicos;
    return s;
  });
});


const filasMesesAnteriores = useMemo(() => {

  const data = Array.isArray(informacionMontosAnteriores)
    ? informacionMontosAnteriores
    : informacionMontosAnteriores?.periodos || [];

  return data.map((mes, idx) => {
    const fila = {
      id: idx + 1,
      periodo: mes.periodo,
      totalMes: Number(mes.total),
      pacientesMes: Number(mes.total_paciente),
    };

    mes.sucursal?.forEach((s) => {
      fila[`totalSucursal_${s.nombre_sucursal}`] = Number(s.monto);
      fila[`pacientesSucursal_${s.nombre_sucursal}`] = Number(s.total_paciente);
    });

    return fila;
  });

}, [informacionMontosAnteriores]);

const listaSucursales = useMemo(() => {

  const data = Array.isArray(informacionMontosAnteriores)
    ? informacionMontosAnteriores
    : informacionMontosAnteriores?.periodos || [];

  const set = new Set();

  data.forEach((mes) => {
    mes.sucursal?.forEach((s) => {
      set.add(s.nombre_sucursal);
    });
  });

  return Array.from(set);

}, [informacionMontosAnteriores]);

const columnasMesAnterior = useMemo(() => {
  const columnas = [
    {
      field: "periodo",
      headerName: "Periodo",
      width: 160,
      renderCell: (params) => {
        const periodo = params.value;
        if (!periodo) return "—";

        const [mes, anio] = periodo.split("-");
        const mesNum = parseInt(mes, 10);
        const mesTexto = nombresMeses[mesNum - 1] || "Mes desconocido";

        return (
          <span style={{ fontWeight: 500 }}>
            {`${mesTexto} ${anio}`}
          </span>
        );
      },
    },
    {
      field: "totalMes",
      headerName: "Total Mes",
      width: 170,
      renderCell: (params) =>
        new Intl.NumberFormat("es-CL", {
          style: "currency",
          currency: "CLP",
          minimumFractionDigits: 0,
        }).format(params.value || 0),
    },
    {
      field: "pacientesMes",
      headerName: "Pacientes Totales Mes",
      width: 200,
    },
  ];

  // 👇 columnas dinámicas por sucursal
  listaSucursales.forEach((nombreSucursal) => {
    columnas.push(
      {
        field: `totalSucursal_${nombreSucursal}`,
        headerName: `Total ${nombreSucursal}`,
        width: 190,
        renderCell: (params) =>
          new Intl.NumberFormat("es-CL", {
            style: "currency",
            currency: "CLP",
            minimumFractionDigits: 0,
          }).format(params.value || 0),
      },
      {
        field: `pacientesSucursal_${nombreSucursal}`,
        headerName: `Pacientes ${nombreSucursal}`,
        width: 200,
      }
    );
  });

  return columnas;
}, [listaSucursales]);



 
  return (
    <Container maxWidth="xl" sx={{ py: 5 }}>
      <Paper
        elevation={4}
        sx={{
          p: 4,
          mb: 7,
          borderRadius: "20px",
          background: "linear-gradient(145deg, #ffffff, #f4f6f8)",
          boxShadow: "0 10px 30px rgba(0,0,0,0.1)"

        }}
      >
        <Box sx={{
          display: "flex",
          justifyContent: 'space-between',
          alignItems: 'center',
          mt: 2
        }}>
          <Box display="flex" alignItems="center" gap={2}>
            <img
              src={Logocolor}
              alt="Logo Clínica Activa"
              style={{ width: 55, height: 55, objectFit: "contain" }}
            />
            <Typography variant="h5" sx={Texto}>
              Ingreso de pacientes
            </Typography>
          </Box>

          <Box display="flex" alignItems="center" gap={2}>
            <Button
              startIcon={< BsFileEarmarkRuledFill />}
              sx={buttonGuardar}
              disabled={loading}
              onClick={() => setOpenImportDialog(true)}
            >
              importar Archivo
            </Button>

            <Button
              startIcon={< IoCreate />}
              sx={buttonAtras}
              disabled={loading}
              onClick={() => setOpenCrearDialog(true)}
            >
              Ingreso Manual
            </Button>

            <Button
              startIcon={<IoTrash />}
              sx={{ ...buttonCancelar }} // puedes usar tu estilo
              onClick={() => setOpenEliminarDialog(true)}
            >
              Eliminar Registro General
            </Button>
          </Box>


        </Box>

      
          <Box mt={5} mb={5} gap={3} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row' }}>

            <Card
              sx={{
                width: '50%',
                backgroundColor: "#ffffff",
                borderRadius: 3,
                boxShadow: "0px 4px 10px rgba(42, 103, 69, 0.4)",
                transition: "transform 0.2s, box-shadow 0.2s",
              }}
            >
              <CardContent
                gap={1}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    width: "80%",
                    flexDirection: "column",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                  }}
                  gap={1}
                  mb={1}
                >
                  <Typography
                    variant="h4"
                    fontWeight={400}
                    sx={{ fontFamily: "Poppins", color: "#585857" }}
                  >
                    {new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP", minimumFractionDigits: 0 }).format( informacionMontos.
total_general
)}
                  </Typography>
                  <Typography
                    variant="h6"
                    fontWeight={500}
                    sx={{ fontFamily: "Poppins", color: "#585857" }}
                  >
                    Total{" "}
                    <Box component="span" sx={{ color: "#2a8d74", fontWeight: 500 }}>
                      Monto Mes  {formatearPeriodo(informacionMontos.periodo)}
                    </Box>
                  </Typography>

                </Box>

                <Box>
                  <GiMoneyStack size={60} color="#5cd09aff" />
                </Box>
              </CardContent>
            </Card>

            <Card
              sx={{
                width: '50%',
                backgroundColor: "#ffffff",
                borderRadius: 3,
                boxShadow: "0px 4px 10px rgba(42, 103, 69, 0.4)",
                transition: "transform 0.2s, box-shadow 0.2s",
              }}
            >
              <CardContent
                gap={1}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    width: "80%",
                    flexDirection: "column",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                  }}
                  gap={1}
                  mb={1}
                >
                  <Typography
                    variant="h4"
                    fontWeight={400}
                    sx={{ fontFamily: "Poppins", color: "#585857" }}
                  >
                    {informacionMontos.cantidad_pacientes_general}
                  </Typography>
                  <Typography
                    variant="h6"
                    fontWeight={500}
                    sx={{ fontFamily: "Poppins", color: "#585857" }}
                  >

                    <Box component="span" sx={{ color: "#2a8d74", fontWeight: 500 }}>
                      Pacientes mes  {formatearPeriodo(informacionMontos.periodo)}
                    </Box>
                  </Typography>

                </Box>

                <Box>
                  <IoPeople size={60} color="#5cd09aff" />
                </Box>
              </CardContent>
            </Card>

          </Box>
       
        <Box >
          <Grid container spacing={1}>
            {informacionMontos?.totales_por_sucursal?.map((sucursal) => (
              <Grid size={{ xs: 12, sm: 6, md: 4, }}>
                <Card
                  key={sucursal.branch_name}
                  sx={{

                    mt: 2,
                    backgroundColor: "#ffffff",
                    borderRadius: 3,
                    boxShadow: "0px 4px 10px rgba(42, 103, 69, 0.4)",
                    transition: "transform 0.2s, box-shadow 0.2s",
                  }}
                >
                  <CardContent
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Box sx={{ display: "flex", flexDirection: "column" }}>

                      <Typography
                        variant="h4"
                        fontWeight={400}
                        sx={{ fontFamily: "Poppins", color: "#585857" }}
                      >
                        {new Intl.NumberFormat("es-CL", {
                          style: "currency",
                          currency: "CLP",
                          minimumFractionDigits: 0,
                        }).format(sucursal.total)}
                      </Typography>

                      <Typography
                        variant="h6"
                        fontWeight={500}
                        sx={{ fontFamily: "Poppins", color: "#585857" }}
                      >
                        Total{" "}
                        <Box component="span" sx={{ color: "#2a8d74", fontWeight: 500 }}>
                          {sucursal.branch_name}
                        </Box>{" "}
                        — {sucursal. cantidad_pacientes} pacientes
                      </Typography>
                    </Box>

                    <Box>
                      <GiMoneyStack size={60} color="#5cd09aff" />
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>



        </Box>

        <Box sx={{ mt: 5 }}>
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            textColor="primary"
            indicatorColor="primary"
            variant="scrollable"   // 👈 evita que se estiren a todo el ancho
            scrollButtons={false}
            TabIndicatorProps={{
              style: {
                backgroundColor: "#6fd385ff", // 👈 mismo verde del tab activo
                height: "3px",             // 👈 grosor de la línea
                borderRadius: "2px",       // 👈 opcional, línea más suave
              },
            }}
            sx={{
              "& .MuiTab-root": {
                minWidth: "auto",
                px: 2,
                textTransform: "none",
                fontFamily: "Poppins",
                fontWeight: 500,
                borderRadius: "8px 8px 0 0", // 👈 esquinas redondeadas arriba (opcional)
              },
              "& .Mui-selected": {
                backgroundColor: "#2a8d74", // 👈 verde oscuro
                color: "#fff !important",   // 👈 letras blancas
              },
            }}>
            <Tab label="Carga masiva" />
            <Tab label="Buscar paciente" />
          </Tabs>

          {tabIndex === 0 && (
            <>
              <IndexCargaMasiva actualizarTabla={actualizarTabla} />

            </>
          )}

          {tabIndex === 1 && (
            <>
              <BusquedaPaciente />
            </>
          )}
        </Box>

        <Box sx={{ width: "100%", mt: 3 }}>
          <Typography variant="h6" sx={{ mb: 2, fontFamily: "Poppins" }}>
            Registro de meses anteriores
          </Typography>

          <DataGrid
            rows={filasMesesAnteriores}
            columns={columnasMesAnterior}
            loading={loadingsIngresosMontos}
            pageSize={5}
            
            rowsPerPageOptions={[5]}
            disableRowSelectionOnClick
            sx={{
              backgroundColor: "#fff",
              borderRadius: "12px",
              boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
              fontFamily: "Poppins",
            }}
          />
        </Box>

      </Paper>

      <Dialog open={openImportDialog} onClose={() => setOpenImportDialog(false)} fullWidth maxWidth="md">
        <DialogTitle sx={TituloColor}>Importar documento  Ingreso Paciente</DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent>
            <TextField
              select
              fullWidth
              sx={Input}
              label="Sucursal (opcional)"
              name="branch_id"
              value={formData.branch_id}
              onChange={(e) =>
                setFormData({ ...formData, branch_id: e.target.value })
              }
            >
              {sucursales.length > 0 ? (
                sucursales.map((sucursal) => (
                  <MenuItem key={sucursal.id} value={sucursal.id}>
                    {sucursal.name}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No hay sucursales disponibles</MenuItem>
              )}
            </TextField>

            <Box sx={{ mt: 3 }}>
              <Button sx={buttonGuardar} component="label">
                Subir archivo Excel
                <input
                  sx={Input}
                  type="file"
                  accept=".xlsx,.xls"
                  hidden
                  onChange={handleFileChange}
                />
              </Button>
            </Box>
            {/* Mostrar nombre del archivo seleccionado */}
            {formData.archivo && (
              <div style={{ fontSize: "0.9rem", color: "#555" }}>
                Archivo seleccionado: {formData.archivo.name}
              </div>
            )}

          </DialogContent>
          <DialogActions>
            <Button sx={buttonGuardar} type="submit" disabled={enviandoAlert}>
              {enviandoAlert ? <CircularProgress size={24} /> : "Importar"}
            </Button>
            <Button sx={buttonCancelar} onClick={() => setOpenImportDialog(false)}>
              Cancelar
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <Dialog
        open={openDeudoresDialog}
        onClose={() => setOpenDeudoresDialog(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle sx={TituloColor}>
          Nuevos deudores detectados
        </DialogTitle>
        <DialogContent>
          {nuevosDeudores.length > 0 ? (
            <Box sx={{ height: 400, width: "100%" }}>
              <DataGrid
                rows={nuevosDeudores.map((d, i) => ({
                  id: i + 1,
                  paciente: d.nombre_paciente,
                  total_deuda: d.total_deuda,
                  saldo_restante: d.saldo_restante,
                  estado: d.estado,
                  rut: d.rut
                }))}
                columns={[
                  { field: "paciente", headerName: "Ingreso Paciente ID", flex: 1 },
                  { field: "rut", headerName: "Rut", flex: 1, renderCell: (params) => FormatRut(params.value) },
                  { field: "total_deuda", headerName: "Total Deuda", flex: 1, renderCell: (params) => formatCLP(params.value) },
                  { field: "saldo_restante", headerName: "Saldo Restante", flex: 1, renderCell: (params) => formatCLP(params.value) },
                  { field: "estado", headerName: "Estado", flex: 1 },
                ]}
                pageSize={5}
                rowsPerPageOptions={[5]}
                disableSelectionOnClick
                slots={{ noRowsOverlay: DiseñoDataGrid }}
                getRowId={(row) => row.id}
                sx={{
                  fontFamily: 'Poppins, sans-serif',
                  '& .MuiDataGrid-columnHeaders': {
                    color: '#113e21ff',
                    fontWeight: 600,
                    textTransform: 'capitalize',
                  },
                  '& .MuiDataGrid-cell': {
                    textTransform: 'capitalize',
                  },
                }}
              />
            </Box>
          ) : (
            <Typography variant="body2" sx={{ color: "#666", mt: 2 }}>
              No se detectaron nuevos deudores.
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button sx={buttonGuardar} onClick={() => setOpenDeudoresDialog(false)}>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>


      <Dialog
        open={openCrearDialog}
        onClose={() => setOpenCrearDialog(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle sx={TituloColor}>Creación manual ingreso paciente</DialogTitle>

        <form onSubmit={handleSubmitManual}>
          <DialogContent>
            {/* 📅 Fechas */}
            <Box sx={{ display: "flex", mt: 2, gap: 2, mb: 2 }}>
              <TextField
                sx={inputFecha}
                name="fecha"
                label="Fecha"
                type="date"
                InputLabelProps={{ shrink: true }}
                fullWidth
                value={crearIngreso.fecha}
                onChange={handleChange}
                required
              />
              <TextField
                sx={inputFecha}
                name="fecha_pago"
                label="Fecha de Pago"
                type="date"
                InputLabelProps={{ shrink: true }}
                fullWidth
                value={crearIngreso.fecha_pago}
                onChange={handleChange}
              />
            </Box>

            {/* 🧍 RUT */}
            <Box sx={{ mb: 2 }}>
              <TextField
                sx={Input}
                name="rut"
                label="RUT"
                fullWidth
                margin="dense"
                value={crearIngreso.rut}
                onChange={handleChange}
                onBlur={() => handleBuscarPaciente("rut")}
                required
                InputProps={{
                  endAdornment: (
                    buscandoPaciente && (
                      <InputAdornment position="end">
                        <CircularProgress size={24} />
                      </InputAdornment>
                    )
                  ),
                }}
              />
            </Box>

            {/* 👤 Nombre Paciente */}
            <Box sx={{ mb: 2 }}>
              <TextField
                sx={{
                  ...Input,
                  '& .MuiInputBase-input': {
                    textTransform: 'capitalize',
                  },
                }}
                name="nombre_paciente"
                label="Nombre Paciente"
                fullWidth
                margin="dense"
                value={crearIngreso.nombre_paciente}
                onChange={handleChange}
                required
                InputProps={{
                  endAdornment: (
                    buscandoPaciente && (
                      <InputAdornment position="end">
                        <CircularProgress size={24} />
                      </InputAdornment>
                    )
                  ),
                }}
              />
            </Box>
            {/* 🏥 Estado Paciente */}
            <Box sx={{ mb: 2 }}>
              <FormControl fullWidth sx={Input}>
                <InputLabel id="estado-paciente-label">Estado del Paciente</InputLabel>
                <Select
                  labelId="estado-paciente-label"
                  name="estado_paciente"
                  value={crearIngreso.estado_paciente}
                  onChange={handleChange}
                  label="Estado del Paciente"
                >
                  <MenuItem value="">Seleccionar...</MenuItem>
                  <MenuItem value="INGRESO">Ingreso</MenuItem>
                  <MenuItem value="REINGRESO">Reingreso</MenuItem>
                  <MenuItem value="EN TERAPIA">Terapia</MenuItem>
                  <MenuItem value="POSTURAGRAFO">Posturagrafo</MenuItem>
                  <MenuItem value="PENDIENTE">Pendiente</MenuItem>
                </Select>
              </FormControl>
            </Box>

            {/* 💳 Previsión */}
            <Box sx={{ mb: 2 }}>
              <FormControl fullWidth sx={Input}>
                <InputLabel id="prevision-label">Previsión</InputLabel>

                <Select
                  labelId="prevision-label"
                  name="prevision"
                  value={crearIngreso.prevision}
                  onChange={handleChange}
                  label="Previsión"
                  disabled={buscandoPaciente}
                >
                  <MenuItem value="">Seleccionar...</MenuItem>

                  {Prevision?.map((item) => (
                    <MenuItem key={item.id} value={item.nombre}>
                      {item.nombre}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>


            {/* 👨‍⚕️ Médico tratante */}
            <Box sx={{ mb: 2 }}>
              <TextField
                sx={Input}
                name="medico_tratante"
                label="Médico Tratante"
                fullWidth
                margin="dense"
                value={crearIngreso.medico_tratante}
                onChange={handleChange}
              />
            </Box>

            {/* 🏢 Sucursal */}

            <Box sx={{ mb: 2 }}>
              <FormControl fullWidth sx={Input}>
                <InputLabel id="sucursal-label">Sucursal</InputLabel>
                <Select
                  labelId="sucursal-label"
                  name="branch_id"
                  value={crearIngreso.branch_id}
                  onChange={handleChange}

                >
                  <MenuItem value="">Seleccionar...</MenuItem>
                  {sucursales?.map((s) => (
                    <MenuItem key={s.id} value={s.id}>
                      {s.name}
                    </MenuItem>
                  ))}
                </Select>



              </FormControl>
            </Box>

            {/* 🧑‍🔬 Profesional */}
            <Box sx={{ mb: 2 }}>
              <FormControl fullWidth sx={Input}>
                <InputLabel id="profesional-label">Profesional</InputLabel>
                <Select
                  labelId="profesional-label"
                  name="kine"
                  value={crearIngreso.kine}
                  onChange={handleChange}
                  label="Profesional"
                >
                  <MenuItem value="">Profesionales Sucursal Selecionada</MenuItem>
                  <MenuItem value="TODOS">Mostrar todos los profesionales</MenuItem>

                  {profesionalesFiltrados.map((p) => (
                    <MenuItem key={p.id} value={p.nombre}>
                      {p.nombre}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>


            {/* 📋 Sesiones */}
            <Box sx={{ mb: 2 }}>
              <TextField
                sx={Input}
                name="n_sesiones"
                label="Sesiones"
                fullWidth
                margin="dense"
                value={crearIngreso.n_sesiones}
                onChange={handleChange}
              />
            </Box>

            {/* 🧾 Episodio */}
            <Box sx={{ mb: 2 }}>
              <TextField
                sx={Input}
                name="episodio"
                label="Episodio"
                fullWidth
                margin="dense"
                value={crearIngreso.episodio}
                onChange={handleChange}
              />
            </Box>

            {/* 💰 Valor */}
            <Box sx={{ mb: 2 }}>
              <TextField
                sx={Input}
                name="monto"
                label="Valor"
                fullWidth
                margin="dense"
                value={crearIngreso.monto ? `$ ${crearIngreso.monto.toLocaleString("es-CL")}` : ""}
                onChange={handleChange}
              />


              <Paper
                elevation={3}
                sx={{
                  mt: 1,
                  p: 2,
                  backgroundColor: "#FFF3CD", // color de aviso tipo importante
                  borderLeft: "5px solid #FFC107", // barra lateral para destacar
                  mb: 2,
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{
                        fontFamily: 'Poppins, sans-serif',
                        fontWeight: 600,
                        color: '#2d4f36ff',
                      }}
                      checked={crearIngreso.estado_pago === "PAGADO"}
                      onChange={(e) =>
                        setCrearIngreso((prev) => ({
                          ...prev,
                          estado_pago: e.target.checked ? "PAGADO" : "NO PAGO",
                        }))
                      }
                    />
                  }
                  label="Pagado"
                  sx={{
                    fontFamily: 'Poppins',
                    fontWeight: 600,
                    color: '#585857',
                  }}
                />
                <FormHelperText sx={{ ml: 5, mt: -1.5, fontFamily: "Poppins", fontWeight: 500 }}>
                  Marca si fue facturado, si no, no hacer clic.
                </FormHelperText>
              </Paper>
            </Box>

            {/* 📝 Observaciones */}
            <Box>
              <TextField
                sx={InputDescripcion}
                name="observaciones"
                label="Observaciones"
                fullWidth
                margin="dense"
                multiline
                rows={3}
                value={crearIngreso.observaciones}
                onChange={handleChange}
              />
            </Box>
          </DialogContent>

          <DialogActions>
            <Button sx={buttonCancelar} onClick={() => setOpenCrearDialog(false)}>
              Cancelar
            </Button>
            <Button sx={buttonGuardar} type="submit" disabled={enviandoAlert}>
              {enviandoAlert ? "Guardando..." : "Guardar"}
            </Button>
          </DialogActions>
        </form>
      </Dialog>


      <Dialog
        open={openEliminarDialog}
        onClose={() => setOpenEliminarDialog(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle sx={TituloColor}>Eliminar Ingresos por Mes y Año</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
            <TextField
              sx={InputBuscador}
              select
              label="Mes"
              fullWidth
              required
              value={mesEliminar}
              onChange={(e) => setMesEliminar(e.target.value)}
            >
              {mesesDisponibles.length > 0 ? (
                mesesDisponibles.map((mes) => (
                  <MenuItem key={mes} value={mes}>
                    {nombresMeses[mes - 1]}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No hay meses disponibles</MenuItem>
              )}
            </TextField>


            <TextField
              sx={InputBuscador}
              select
              label="Año"
              fullWidth
              required
              value={anioEliminar}
              onChange={(e) => setAnioEliminar(e.target.value)}
            >
              {aniosDisponibles.length > 0 ? (
                aniosDisponibles.map((anio) => (
                  <MenuItem key={anio} value={anio}>
                    {anio}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No hay años disponibles</MenuItem>
              )}
            </TextField>

             <TextField
              sx={InputBuscador}
              select
              label="Sucursal"
              fullWidth
              required
              value={SucursalEliminar}
              onChange={(e) => setSucursalEliminar(e.target.value)}
            >
              {sucursales.length > 0 ? (
                sucursales.map((sucursal) => (
                  <MenuItem key={sucursal.id} value={sucursal.id}>
                    {sucursal.name}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No hay sucursal disponibles</MenuItem>
              )}
            </TextField>

          </Box>
        </DialogContent>

        <DialogActions>
          <Button sx={buttonCancelar} onClick={() => setOpenEliminarDialog(false)}>
            Cancelar
          </Button>
          <Button
            sx={buttonGuardar}
            disabled={!mesEliminar || !anioEliminar || !SucursalEliminar || loading}
            onClick={() => setOpenConfirmEliminar(true)}
          >
            Eliminar
          </Button>

        </DialogActions>
      </Dialog>
      <Dialog
        open={openConfirmEliminar}
        onClose={() => setOpenConfirmEliminar(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ color: "#b71c1c", fontWeight: 600 }}>
          Confirmar eliminación
        </DialogTitle>

        <DialogContent>
          <Typography sx={{ mt: 1 }}>
            ⚠️ Esta acción <strong>NO se puede deshacer</strong>.
          </Typography>

          <Typography sx={{ mt: 2 }}>
            ¿Estás segura que deseas eliminar todos los ingresos del
            <strong> mes {nombresMeses[mesEliminar - 1]}</strong> del
            <strong> año {anioEliminar}</strong> de la sucursal?
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button
            sx={buttonCancelar}
            onClick={() => setOpenConfirmEliminar(false)}
          >
            Cancelar
          </Button>

          <Button
            sx={{
              ...buttonGuardar,
              backgroundColor: "#d32f2f",
              "&:hover": { backgroundColor: "#b71c1c" },
            }}
            onClick={async () => {
              try {
                setLoading(true);

                await eliminarIngresoPacienteMesyAño(
                  Number(mesEliminar),
                  Number(anioEliminar),
                   Number(SucursalEliminar)
                );

                setAlertMessage(
                  `Se eliminaron los ingresos de ${mesEliminar}/${anioEliminar} ✅`
                );
                setSuccessAlertOpen(true);

                await refetchIP();
                await refetchBP();
              } catch (error) {
                setAlertMessage(error || "Error al eliminar ingresos ❌");
                setErrorAlertOpen(true);
              } finally {
                setLoading(false);
                setOpenConfirmEliminar(false);
                setOpenEliminarDialog(false);
              }
            }}
          >
            Sí, eliminar
          </Button>
        </DialogActions>
      </Dialog>

    <Dialog
  open={openConfirmNoPagoDialog}
  onClose={() => setOpenConfirmNoPagoDialog(false)}
  fullWidth
  maxWidth="lg"
>
    <IconButton
    onClick={handleCloseDialog}
    sx={{ position: 'absolute', right: 8, top: 8 }}
  >
    <CloseIcon />
  </IconButton>
  <DialogTitle sx={TituloColor}>
    Confirmar regularización de NO PAGOS
  </DialogTitle>

  <DialogContent dividers sx={{ maxHeight: "70vh" }}>
    

  {noPagosDetectados.length === 0 ? (

    // 🔥 ESTADO VACÍO
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="300px"
      textAlign="center"
    >
      <CheckCircleIcon sx={{ fontSize: 60, color: "#4caf50", mb: 2 }} />

      <Typography
        sx={{
          fontFamily: 'Poppins',
          fontWeight: 600,
          fontSize: '1.2rem',
          color: '#2e7d32'
        }}
      >
        No hay más regularizaciones pendientes
      </Typography>

      <Typography
        sx={{
          fontFamily: 'Poppins',
          fontWeight: 400,
          color: '#666',
          mt: 1
        }}
      >
        Todos los registros han sido revisados correctamente
      </Typography>
    </Box>

  ) : (
    noPagosDetectados.map((item, index) => {
      if (!item?.no_pago_anterior || !item?.pago_actual) return null;

      return (
        <Paper key={index} sx={{ p: 2, mb: 2 }}>
          <Typography fontWeight={600} sx={TituloPrincipal}>
            {item.paciente}
          </Typography>

           <Typography  sx={{color:"#585857", fontFamily:'Poppins', fontWeight:500,mb:1}}>
              Usuario presenta un registro de NO PAGO. Confirma que deseas asociar pago.
           </Typography>
          <Grid container spacing={2} mt={2}>
            {/* NO PAGO ANTERIOR */}
            <Grid size={{xs:12,sm:6}}>
              <Paper sx={{ p: 2, bgcolor: "#f4b1b1",height:100 }}>
                <Typography  sx={{color:"#511b1b", fontFamily:'Poppins', fontWeight:500,mb:1}}>
                  Registro anterior de no pago
                </Typography>
                <Typography sx={{color:"#5858575", fontFamily:'Poppins', fontWeight:500,}}>
                  Fecha: {item.no_pago_anterior.fecha_pago}
                </Typography>
                
              </Paper>
            </Grid>

            {/* PAGO ACTUAL */}
            <Grid size={{xs:12,sm:6}}>
              <Paper sx={{ p: 2, bgcolor: "#e8f5e9", height:100 }}>
                <Typography  sx={{color:"#33763d", fontFamily:'Poppins', fontWeight:500,mb:1}}>
                  Registro de pago actual
                </Typography>
                <Typography sx={{color:"#5858575", fontFamily:'Poppins', fontWeight:500,}}>
                  Fecha: {item.pago_actual.fecha_pago}
                </Typography >
                <Typography sx={{color:"#5858575", fontFamily:'Poppins', fontWeight:500,}}>
                  Monto: {formatCLP(item.pago_actual.monto)}
                </Typography>
                <Typography variant="caption" sx={{color:"#5858575", fontFamily:'Poppins', fontWeight:500,}}>
                  Diferencia: {item.dias_diferencia} días
                </Typography>
              </Paper>
            </Grid>
          </Grid>

          <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
            <Button
              sx={buttonCancelar}
              onClick={() => handleNoConfirmar(item.no_pago_anterior.id)}
            >
              No confirmar
            </Button>

            <Button
              sx={buttonGuardar}
              disabled={confirmandoId === item.no_pago_anterior.id}
              onClick={() => handleConfirmarNoPago(item.no_pago_anterior.id)}
            >
              Confirmar
            </Button>
          </Box>
        </Paper>
      );
    })

  )}
  </DialogContent>
</Dialog>





      <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
        <Box sx={modalStyle}>
          <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
            <IoClose />
          </section>
          <section style={{ textAlign: "center" }}>
            <FaRegCircleCheck style={{ color: "green", fontSize: "2rem" }} />
            <p className="alert-text">{alertMessage}</p>
          </section>
        </Box>
      </Modal>

      <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
        <Box sx={modalStyle}>
          <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
            <IoClose />
          </section>
          <section style={{ textAlign: "center" }}>
            <BiErrorCircle style={{ color: "red", fontSize: "2rem" }} />
            <p className="alert-text">{alertMessage}</p>
          </section>
        </Box>
      </Modal>

      <Modal open={enviandoAlert}>
        <Box sx={modalStyle}>
          <section style={{ textAlign: "center", padding: "1rem" }}>
            <CircularProgress style={{ color: "#2a8d74" }} />
            <p className="alert-text">Procesando solicitud...</p>
          </section>
        </Box>
      </Modal>
    </Container>
  );
};
